// UI-only job-group types. The platform API persists only name + description, so the
// type rides inside the description as a trailing "[c2type:KEY]" marker that the UI
// strips before display. If a real column lands later, this codec is the only thing
// that has to change.
export const GROUP_TYPES = [
  { key: 'MULTI_TARGET_MASKING', label: 'Multi Target Masking' },
  { key: 'APP_CLUSTER', label: 'App Cluster' },
  { key: 'REINFORCED_LEARNING_ENV', label: 'Reinforced Learning Env' },
  { key: 'GENERAL', label: 'General' },
];

export const DEFAULT_GROUP_TYPE = 'GENERAL';

const KNOWN_KEYS = new Set(GROUP_TYPES.map((t) => t.key));
const MARKER_RE = /\s*\[c2type:([A-Z_]+)\]\s*/g;

export const typeLabel = (key) => {
  const found = GROUP_TYPES.find((t) => t.key === key);
  return found ? found.label : typeLabel(DEFAULT_GROUP_TYPE);
};

// Clean description + type key -> raw description to persist. Always writes the marker
// (even for GENERAL) so a tagged group is distinguishable from a legacy untagged one.
export function encodeGroupType(description, typeKey) {
  const key = KNOWN_KEYS.has(typeKey) ? typeKey : DEFAULT_GROUP_TYPE;
  const clean = (description || '').trim();
  return clean ? `${clean} [c2type:${key}]` : `[c2type:${key}]`;
}

// Raw persisted description -> { typeKey, description } with every marker stripped.
// Untagged (legacy) groups and unknown keys fold into GENERAL.
export function decodeGroupType(rawDescription) {
  const raw = rawDescription || '';
  let typeKey = DEFAULT_GROUP_TYPE;
  const match = raw.match(/\[c2type:([A-Z_]+)\]/);
  if (match && KNOWN_KEYS.has(match[1])) typeKey = match[1];
  const description = raw.replace(MARKER_RE, ' ').trim() || null;
  return { typeKey, description };
}
